import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Select from 'react-select'
import { translate, Trans, i18n } from 'react-i18next'

const styles = theme => ({
    flex: {
        flex: 1,
    }
})

let selectedOption

class Footer extends Component {
    constructor(props) {
      super(props)
    }
  
    componentDidMount() {
        const { classes, isFetchingPosts, posts, i18n } = this.props

        switch(i18n.language) {
            case 'zh-TW':
                selectedOption = 'zh-Hant-TW'
                i18n.changeLanguage(selectedOption)
                break
            case 'en':
            case 'zh-Hant-TW':
            case 'ja':
                selectedOption = i18n.language
                break
            default:
                selectedOption = 'en'
        }
    }

    render() {
        const { classes, isFetchingPosts, posts, i18n } = this.props

        const changeLanguage = (selected) => {
            selectedOption = selected.value
            i18n.changeLanguage(selected.value)
        }

        return (
            <Select
                name="select-languge"
                className={classes.flex}
                value={selectedOption}
                onChange={changeLanguage}
                clearable={false}
                options={[
                { value: 'en', label: 'English' },
                { value: 'zh-Hant-TW', label: '繁體中文' },
                { value: 'ja', label: '日本語' }
                ]}
            />
        )
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
}
  
export default translate('translations')(withStyles(styles)(Footer))


// WEBPACK FOOTER //
// ./src/components/Footer.js